import type { ButtonHTMLAttributes, ReactNode } from "react";

export type ButtonTone = "primary" | "secondary" | "pill" | "quiet" | "destructive";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  tone?: ButtonTone;
  /** Primary buttons on a landing or a spend screen breathe. Use once per screen. */
  breathe?: boolean;
  /** Shrink to content instead of filling the column. */
  auto?: boolean;
  children: ReactNode;
}

const toneClass: Record<ButtonTone, string> = {
  primary: "btn-primary",
  secondary: "btn-secondary",
  pill: "btn-pill",
  quiet: "btn-quiet",
  destructive: "btn-destructive",
};

export function Button({ tone = "primary", breathe = false, auto = false, className, children, ...rest }: ButtonProps) {
  const classes = ["btn", toneClass[tone], auto ? "btn-auto" : "", breathe ? "anim-breathe" : "", "press-bounce", className]
    .filter(Boolean)
    .join(" ");
  return (
    <button type="button" className={classes} {...rest}>
      {children}
    </button>
  );
}
